module.exports = __webpack_public_path__ + "media/tips/05_planete_balance-41ece93e.png";